var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"h-a-steps-circle"},_vm._l((_vm.steps),function(step,index){return _c('li',{class:{ 'active': index <= _vm.activeIndex }},[_c('div',[_c('span',{staticClass:"number"},[_vm._v(_vm._s(index+1))]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(step))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }